

















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { UserViewModel, UserService } from '../../api/user';
@Component({})
export default class ResetPassword extends Vue {
  @Prop() private userId!: string;
  private service: UserService = new UserService();
  private data: UserViewModel = this.service.NewModel;
  private rules = {
    password: [{required: true, message: '请输入新密码', trigger: 'blur'}],
  };
  @Emit('OnCancel')
  private OnCancel() { }
  @Emit('OnSaved')
  private OnSaved() { }

  private btnSave_OnClick() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        this.data.id = this.userId;
        this.service.ResetPassword(this.data).then((response: any) => {
          (this.$refs['edit-form'] as any).resetFields();
          this.OnSaved();
        });
      }
    });
  }

}
